import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ModalService } from "@app2/shared/modal/modal.service";
import { RecentTicketsService } from "@app2/shared/services/recent-tickets.service";
import { TicketSelectionModalComponent } from "@app2/ticket/shared/ticket-selection-modal.component";
import { INCIDENT_SLUG, SlugName } from "@app2/ticket/ticket-constants";
import { Ticket, TicketSummary } from "@app2/type-defs/ticket/ticket-types";
import { Observable } from "rxjs";

@Component({
    selector: "ticket-actions-dropdown",
    template: `
        <pr-dropdown align="right"
                     (popupShown)="refreshRecentTickets()">
            <ng-content></ng-content>
            <ul pr-dropdown-body test-class="escalate-dropdown" class="pr-dropdown">
                <li (click)="ticketSelect.emit({slugName: 'incident'})"
                    test-class="new-incident-button">
                    {{'NEW_INCIDENT' | localize}}
                </li>
                <li (click)="ticketSelect.emit({slugName: 'task'})"
                    test-id="create-new-task">
                    {{'NEW_TASK' | localize}}
                </li>
                <li (click)="showSearchTicketModal('incident')"
                    class="border-top">
                    {{'SEARCH_INCIDENT' | localize}}
                </li>
                <li (click)="showSearchTicketModal('task')">
                    {{'SEARCH_TASK' | localize}}
                </li>
                <ng-container *ngIf="recentTickets$ | async; let recentTickets">
                    <ng-container *ngIf="recentTickets.length > 0">
                        <li class="recent-title no-hover border-top">{{'RECENTLY_VIEWED' | localize}}</li>
                        <li class="add-to-ticket" test-id="add-to-ticket-button"
                            *ngFor="let ticket of recentTickets"
                            (click)="ticketSelect.emit({slugName: ticket.slugName, slugId: ticket.slugId})">
                            {{ticket.slugName}}/{{ticket.slugId}} {{addEllipsis(ticket.summary)}}
                        </li>
                    </ng-container>
                </ng-container>
            </ul>
        </pr-dropdown>
    `,
})
export class TicketActionsDropdownComponent implements OnInit {

    @Output() ticketSelect = new EventEmitter<{ slugName: SlugName; slugId?: number }>();

    recentTickets$: Observable<TicketSummary[]>;

    constructor(private recentTicketsService: RecentTicketsService,
                private modalService: ModalService) {
    }

    ngOnInit() {
        this.recentTickets$ = this.recentTicketsService.getRecentItems$();
    }

    showSearchTicketModal(slugName: SlugName): void {
        this.modalService
            .open(TicketSelectionModalComponent, {
                titleKey: slugName === INCIDENT_SLUG ? "SEARCH_INCIDENT" : "SEARCH_TASK",
                slugName,
                returnAndClose: true,
            }, { width: "80%", height: "80%" })
            .afterClosedWithResult()
            .subscribe((ticket: Ticket) => {
                this.ticketSelect.emit({ slugName, slugId: ticket.slugId });
            });
    }

    refreshRecentTickets() {
        this.recentTicketsService.refresh();
    }

    addEllipsis(text: string): string {
        return text.length > 80
            ? text.substr(0, 80) + "..."
            : text;
    }
}
